module.exports = __webpack_public_path__ + "img/close-button.319e6e1f.png";